class EventManager {

    constructor() {
        this.observerList = {
            EVENT_NEWS_PREVIEW_CLICK    : [],
            EVENT_NEWS_VIEW_CLICK       : [],
            EVENT_TEASER_CLICK          : [],
            EVENT_LOAD_NEWS             : [],
            EVENT_LOAD_TEASERS          : [],
            EVENT_BACK                  : [],
            EVENT_READ_NEWS             : [],
            EVENT_LOAD_PAGE             : [],
            EVENT_SMART_BACK            : [],
            EVENT_BEFORE_REQUEST_TEASERS: [],
            // EVENT_SEND_PIXEL_DMP        : [],
        };
    }

    addObserverList(list) {
        this.observerList[list] = [];
    }

    subscribeAll(callback){
        for (let eventType in this.observerList){
            this.observerList[eventType].push(callback);
        }
    }

    subscribe(eventType, callback){
        this.observerList[eventType].push(callback);
    }

    notify(eventType, data) {
        console.log('event', eventType);

        for(let i in this.observerList[eventType])  {
            this.observerList[eventType][i](data, eventType);
        }
    }

}

module.exports = EventManager;